/// <reference path="../../public/jquery-1.6.2.min.js" />
/// <reference path="../../public/AJAX.js" />
/// <reference path="../../public/General.js" />
/// <reference path="../../public/Security.js" />
/// <reference path="../../public/ServiceURL.js" />
/// <reference path="../../SumoDataAccess.js" />
/// <reference path="../../SumoClass.js" />
/// <reference path="../ControlBase.js" />

if (isNullOrUndefined(sumo)) {
    throw ('Label.js requies the sumo namespace defined in SumoClass.js');
}

if (isNullOrUndefined(sumo.maps)) {
    sumo.maps = {};
}

// ---------------------------------------------------------
// sumo.maps.Label
// ---------------------------------------------------------
// options
//  text, cssClass, position, data, map
sumo.maps.Label = function (aOptions) {
    "use strict";

    var mCssClass = '',
        //mData = null,
        mIsVisible = false,
        //mhoverHtml = '',
        mDiv = null,
        mText = '',
        mPosition = null,
        mZIndex = 0,
        mVerticalOffset = 0,
        mHorizontalOffset = 0,
        mMap = null;

    if (!isNullOrUndefined(aOptions)) {
        if (!isNullOrUndefined(aOptions.text)) {
            mText = aOptions.text;
        }
        if (!isNullOrUndefined(aOptions.cssClass)) {
            mCssClass = aOptions.cssClass;
        }
        if (!isNullOrUndefined(aOptions.position)) {
            mPosition = aOptions.position;
        }
        if (!isNullOrUndefined(aOptions.visible)) {
            mIsVisible = aOptions.visible;
        }
        if (!isNullOrUndefined(aOptions.zIndex)) {
            mZIndex = aOptions.zIndex;
        }
        if (!isNullOrUndefined(aOptions.verticalOffset)) {
            mVerticalOffset = aOptions.verticalOffset;
        }
        if (!isNullOrUndefined(aOptions.horizontalOffset)) {
            mHorizontalOffset = aOptions.horizontalOffset;
        }
        if (!isNullOrUndefined(aOptions.map)) {
            mMap = aOptions.map;
            this.setMap(mMap);
        }
    }

    this.onAdd = function () {
        mDiv = document.createElement('div');
        mDiv.style.position = 'absolute';
        mDiv.className = mCssClass;
        mDiv.innerHTML = mText;
        mDiv.style.zIndex = mZIndex;
        mDiv.style.visibility = "hidden";
        this.getPanes().overlayLayer.appendChild(mDiv);
    };

    this.draw = function () {
        var lProjection,
            lPoint,
            lValue;
        lProjection = this.getProjection();

        lPoint = lProjection.fromLatLngToDivPixel(mPosition);

        if (!isNaN(lPoint.x) && !isNaN(lPoint.y)) {
            lValue = lPoint.x + mHorizontalOffset;
            mDiv.style.left = lValue.toString() + 'px';
            lValue = lPoint.y + mVerticalOffset;
            mDiv.style.top = lValue.toString() + 'px';
        }
        if (mIsVisible) {
            mDiv.style.visibility = "visible";
        } else {
            mDiv.style.visibility = "hidden";
        }
    };

    this.onRemove = function () {
        mDiv.parentNode.removeChild(mDiv);
        mDiv = null;
    };

    this.show = function () {
        mIsVisible = true;
        mDiv.style.visibility = 'visible';
    };

    this.hide = function () {
        mIsVisible = false;
        mDiv.style.visibility = 'hidden';
    };

    this.getPosition = function () {
        return mPosition;
    };

    this.getVisible = function () {
        return mIsVisible;
    };

    this.setVisible = function (aValue) {
        mIsVisible = aValue;
        if (mDiv !== null) {
            if (aValue) {
                this.show();
            } else {
                this.hide();
            }
        }
    };
};
sumo.maps.Label.prototype = new google.maps.OverlayView();